import GenericRequest, { METHOD_POST } from '../../../../../shared/webservices/GenericRequest';

export class CompanyUpdateTask extends GenericRequest {

    _request; // CompanyUpdateRequest

    constructor(request) {
        super(METHOD_POST, request.url());
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }
}



// WEBPACK FOOTER //
// ./src/app/my-company/company/form/update/company-update/CompanyUpdateTask.js